module.exports = "<v-container> <v-layout row wrap> <v-flex xs12> <v-text-field label=\"Podaj Identyfikator w systemie bilingowym\" placeholder=\"Podaj Identyfikator w systemie bilingowym\" type=text v-model=watermeterBillingId autofocus v-on:input=\"updateValue('watermeterBillingId', $event)\"></v-text-field> </v-flex> </v-layout> </v-container> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/viewer/edition/template/templateDialogAddWatermeters.html
// module id = 2157
// module chunks = 0